import { ResourceCenterStrings } from "./resource-center-strings.js";
import { htmlEncode } from "./resource-center-sanitize.js";

export class ResourceCenterApiUrlService {
  constructor(settings) {
    this.widgetSettings = settings || {};
    this.oDataSettings = settings.ODataSettings || {};
    this.defaults = settings.UrlSettings || {
      filter: '$filter=',
      containsSegment: 'contains',
      expand: '$expand=',
      culture: 'sf_culture=',
      skip: '$skip=',
      take: '$top=',
      count: '$count=true',
      joinById: ' or id eq '
    }
  }

  generate(pageNumber, currentSelections) {
    let filterSegments = [];
    filterSegments = filterSegments.concat(this.oDataSettings.FilterSegments);
    const excludeTaxa = this.getTaxaUrls(this.oDataSettings.ExcludedTaxonomies, 'x ne');
    if (excludeTaxa) {
      filterSegments.push(`(${excludeTaxa})`);
    }

    let taxonomiesExpression = [];
    currentSelections.selectedTaxonomies.forEach(selectedTaxonomy => {
      const taxaUrl = this.getTaxaUrls(selectedTaxonomy, 'x eq');
      if (taxaUrl) {
        taxonomiesExpression.push(`(${taxaUrl})`);
      }
    });

    if (taxonomiesExpression.length > 0) {
      filterSegments.push(taxonomiesExpression.join(' and '));
    }
    const searchUrl = this.getApiSearchData(currentSelections.searchTerm);
    if (searchUrl) {
      filterSegments.push(searchUrl)
    }

    let queryParams = [];
    if (filterSegments.length > 0) {
      queryParams.push(`${this.defaults.filter}${filterSegments.join(' and ')}`);
    }
    const skipCount = this.widgetSettings.DisablePaging ? 0 : `${this.defaults.skip}${(pageNumber - 1) * this.oDataSettings.PageSize}`;
    const takeCount = this.widgetSettings.DisablePaging ? 0 : `${this.defaults.take}${this.oDataSettings.PageSize}`;
    const expands = this.getExpandedFieldsQuery();
    let culture = "";
    if (currentSelections.language) {
      culture = `${this.defaults.culture}${currentSelections.language}`;
    }

    queryParams.push(culture,
      expands,
      this.oDataSettings.SelectedFields,
      this.oDataSettings.OrderBy,
      skipCount,
      takeCount,
      this.defaults.count);

    const defaultUrl = this.oDataSettings.Endpoint + '?' + queryParams.filter(removeEmptyEntries => removeEmptyEntries).join('&');
    let apiRequestUrl = {
      url: defaultUrl
    };
    const onOdataUrlGenerated = new CustomEvent("onResourceCenterOdataUrlGenerationCompleted", { detail: apiRequestUrl });
    document.dispatchEvent(onOdataUrlGenerated);

    return apiRequestUrl.url;
  }

  getExpandedFieldsQuery() {
    let query = [];

    const imageQuery = this.getImageQuery();
    if (imageQuery) {
      query.push(imageQuery);
    }

    if (this.oDataSettings.ExpandedFields.CommonFields.length > 0) {
      query.push(this.oDataSettings.ExpandedFields.CommonFields.join(','));
    }

    return query.length > 0 ? `${this.defaults.expand}${query.join(',')}` : "";
  }

  getTaxaUrls(taxonomies, taxaComparer) {
    let url = "";
    if (!taxonomies || Object.keys(taxonomies).length === 0) {
      return url;
    }
    let count = 0;
    for (let taxonomyName in taxonomies) {

      if (count > 0) { url += ' ' + taxonomies[taxonomyName].taxonomyOperator + ' ' }
      let opetator = taxonomies[taxonomyName].taxaOperator || 'or';
      url += taxonomyName + (opetator == 'or' ? '/any(x:' + taxaComparer + ' ' : '/all(x:' + taxaComparer + ' ');
      url += taxonomies[taxonomyName].taxa.join(' ' + opetator + ' ' + taxaComparer + ' ') + ')';

      count++;
    }
    url = url.replace(ResourceCenterStrings.categoriesKeyName, 'category');
    url = url.replace(ResourceCenterStrings.contentTypesKeyName, 'contenttypes');
    return url;
  }

  getApiSearchData(searchTerm) {
    let search = "";
    if (searchTerm.length > 0) {
      let segments = []
      const sanitizedTerm = this.sanitizeValueForUrl(searchTerm);

      this.oDataSettings.ContainsFields.forEach(field => {
        segments.push(`${this.defaults.containsSegment}(${field},'${sanitizedTerm}')`)
      });

      if (segments.length > 0) {
        search += `(${segments.join(' or ')})`;
      }
    }

    return search;
  }

  sanitizeValueForUrl(value) {
    let cleanValueFromSpecialCharacters = value.replace("'", "''");
    return encodeURIComponent(htmlEncode(cleanValueFromSpecialCharacters));
  }

  getImagesUrl_english(resourceIds) {
    let url = '';
    const imageQuery = this.getImageQuery();
    if (imageQuery) {
      url = `${this.oDataSettings.Endpoint}?${this.defaults.filter}(id eq ${resourceIds.join(this.defaults.joinById)})&$select=id&${this.defaults.expand}${imageQuery}`
    }
    return url;
  }

  getImageQuery() {
    if (this.oDataSettings.ExpandedFields.Image) {
      return Object.values(this.oDataSettings.ExpandedFields.Image)[0];
    }
    return "";
  }
}
